<template>
  <div class="invoice">
    <h2 class="tit-30 fw700">我的发票</h2>
    <!-- 已有发票列表区域 -->
    <div class="invoice-list">
      <div
        class="invoice-card"
        v-for="(invoice, index) in sortedinvoiceList"
        :key="index"
      >
        <div class="invoice-info">
          <div class="default tit-14 cor-fff" v-if="invoice.isDefault==1">
            默认
          </div>
          <div class="tit-16 cor-8080">{{ invoice.invoiceType }}</div>
          <div class="tit-18 cor-000 mt-10 mb-10">
            {{ invoice.invoiceTitle }}
          </div>
          <div
            class="tit-14 cor-8080"
            v-if="invoice.invoiceType === '个人数电普票'"
          >
            {{ invoice.email }}
          </div>
          <div class="tit-14 cor-8080">{{ invoice.taxNumber }}</div>
        </div>
        <div class="invoice-actions">
          <div class="edit" @click="handleEdit(index)">
            <i class="el-icon-edit-outline tit-18"></i>
            <span class="tit-14 ml-10">修改</span>
          </div>
          <div class="delete" @click="handleDelete(index)">
            <i class="el-icon-delete tit-18"></i>
            <span class="tit-14 ml-10">删除</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 空状态 -->
    <div v-if="invoiceList.length === 0" class="empty-state">
      <el-empty description="暂无发票信息"></el-empty>
    </div>

    <!-- 添加新地址按钮 -->
    <div class="add-invoice flex-cc" @click="handleAdd">
      <i class="el-icon-circle-plus-outline tit-24"></i>
      <span class="ml-10">添加发票抬头</span>
    </div>

    <!-- 编辑/添加发票弹窗 -->
    <el-dialog
      title="添加发票抬头"
      :visible.sync="dialogVisible"
      class="invoiceDialog"
    >
      <el-form :model="form" label-width="80px" :rules="rules" ref="formRef">
        <el-radio-group v-model="form.invoiceType">
          <el-radio label="企业数电普票" border>企业数电普票</el-radio>
          <el-radio label="企业数电专票" border>企业数电专票</el-radio>
          <el-radio label="个人数电普票" border>个人数电普票</el-radio>
        </el-radio-group>
        <template
          v-if="
            form.invoiceType === '企业数电普票' ||
              form.invoiceType === '企业数电专票'
          "
        >
          <el-form-item label="发票抬头" prop="invoiceTitle">
            <el-input v-model="form.invoiceTitle"></el-input>
          </el-form-item>
          <el-form-item
            label="单位税号"
            v-if="
              form.invoiceType === '企业数电普票' ||
                form.invoiceType === '企业数电专票'
            "
            prop="taxNumber"
          >
            <el-input v-model="form.taxNumber"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="email">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item
            label="开户银行"
            v-if="
              form.invoiceType === '企业数电普票' ||
                form.invoiceType === '企业数电专票'
            "
            prop="bank"
          >
            <el-input v-model="form.bank"></el-input>
          </el-form-item>
          <el-form-item
            label="银行账号"
            v-if="
              form.invoiceType === '企业数电普票' ||
                form.invoiceType === '企业数电专票'
            "
            prop="bankAccount"
          >
            <el-input v-model="form.bankAccount"></el-input>
          </el-form-item>
          <el-form-item
            label="企业地址"
            v-if="
              form.invoiceType === '企业数电普票' ||
                form.invoiceType === '企业数电专票'
            "
            prop="companyAddress"
          >
            <el-input v-model="form.companyAddress"></el-input>
          </el-form-item>
          <el-form-item
            label="企业电话"
            v-if="
              form.invoiceType === '企业数电普票' ||
                form.invoiceType === '企业数电专票'
            "
            prop="companyPhone"
          >
            <el-input v-model="form.companyPhone"></el-input>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="发票抬头" prop="invoiceTitle">
            <el-input v-model="form.invoiceTitle"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="contactPhone">
            <el-input v-model="form.contactPhone"></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="email">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
        </template>
        <el-form-item>
          <el-checkbox v-model="form.isDefault">设为默认</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
let that;
export default {
  name: "InvoiceManagement",
  data() {
    return {
      invoiceList: [
        // {
        //   id: 1,
        //   invoiceType: "企业数电普票",
        //   invoiceTitle: "张三有限公司",
        //   taxNumber: "123456789",
        //   email: "123456789@qq.com",
        //   bank: "中国工商银行",
        //   bankAccount: "123456789",
        //   companyAddress: "北京市朝阳区",
        //   companyPhone: "010-12345678",
        //   contactPhone: "18712345678",
        //   isDefault: true,
        // },
      ],
      dialogVisible: false,
      form: {
        id: null,
        invoiceType: "企业数电普票",
        invoiceTitle: "",
        taxNumber: "",
        email: "",
        bank: "",
        bankAccount: "",
        companyAddress: "",
        companyPhone: "",
        contactPhone: "",
        isDefault: false,
      },

      rules: {
        invoiceType: [
          { required: true, message: "请选择发票类型", trigger: "change" },
        ],
        invoiceTitle: [
          { required: true, message: "请输入发票抬头", trigger: "blur" },
        ],
        taxNumber: [
          { required: true, message: "请输入单位税号", trigger: "blur" },
        ],
        email: [{ required: true, message: "请输入电子邮箱", trigger: "blur" }],
        bank: [{ message: "请输入开户银行", trigger: "blur" }],
        bankAccount: [{ message: "请输入银行账号", trigger: "blur" }],
        companyAddress: [{ message: "请输入企业地址", trigger: "blur" }],
        companyPhone: [{ message: "请输入企业电话", trigger: "blur" }],
        contactPhone: [
          { message: "请输入联系电话", trigger: "blur" },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: "手机号格式不正确",
            trigger: ["blur", "change"],
          },
        ],
        isDefault: [
          { required: true, message: "请选择是否设为默认", trigger: "change" },
        ],
      },
      currentAction: "add", // 当前操作：添加或编辑
    };
  },

  created() {
    that = this;
    // 组件创建时加载地址列表
    // this.loadinvoiceList();
    this.CSH();
  },

  computed: {
    // 计算属性：默认地址排在最前面
    sortedinvoiceList() {
      return [...this.invoiceList].sort((a, b) => {
        if (a.isDefault && !b.isDefault) return -1;
        if (!a.isDefault && b.isDefault) return 1;
        return 0;
      });
    },
  },

  methods: {
    // 加载地址列表
    CSH() {
      that.$post("k=invoice", function(s) {
        that.invoiceList = s.shu;
        // this.zongshu = Number(s.shu.zongshu);
      });
    },
    // loadinvoiceList() {
    //   this.loading = true;
    //   // 模拟API请求 - 实际项目中替换为真实API调用
    //   this.$http
    //     .get("/api/address/list")
    //     .then((response) => {
    //       this.invoiceList = response.data || [];
    //     })
    //     .catch((error) => {
    //       console.error("加载地址列表失败:", error);
    //       this.$message.error("加载地址列表失败");
    //     })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // },

    // 处理添加新地址
    handleAdd() {
      this.currentAction = "add";
      // 重置表单数据
      this.form = {
        invoiceType: "企业数电普票",
        invoiceTitle: "",
        taxNumber: "",
        email: "",
        bank: "",
        bankAccount: "",
        companyAddress: "",
        companyPhone: "",
        contactPhone: "",
        isDefault: false,
      };
      this.dialogVisible = true;
    },

    // 处理编辑地址
    handleEdit(index) {
      this.currentAction = "edit";
      // 复制选中的地址数据到表单
      // 获取排序后的地址ID
      const sortedId = this.sortedinvoiceList[index].id;
      // 在原始数组中查找对应的地址
      const originalIndex = this.invoiceList.findIndex(
        (item) => item.id === sortedId,
      );

      this.form = JSON.parse(JSON.stringify(this.invoiceList[originalIndex]));
      this.dialogVisible = true;
    },

    // 处理删除地址
    handleDelete(index) {
      const invoice = this.invoiceList[index];
      // 不能删除唯一的默认地址
      if (invoice.isDefault && this.invoiceList.length === 1) {
        this.$message.warning("不能删除唯一的默认地址");
        return;
      }

      this.$confirm("此操作将永久删除该地址, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.$post(
            "k=invoice&c=shan",
            { id: that.invoiceList[index].id },
            function(shu) {
              if (shu.shi == 1) {
                that.CSH();
                that.$message({
                  type: "success",
                  message: "删除成功!",
                });
              }
            },
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    // 提交表单
    submitForm() {
      that.$refs.formRef.validate((valid) => {
        if (valid) {
          // 如果设为默认地址，先将其他地址设为非默认
          if (that.form.isDefault) {
            that.invoiceList.forEach((item) => {
              item.isDefault = false;
            });
          }
          that.$post("k=invoice&c=xiugai", that.form, function(s) {
            if (s.shi == 1) {
              if (that.currentAction === "add") {
                // 添加新地址
                that.$message.success("添加成功");
              } else {
                that.$message.success("修改成功");
              }
            }
            that.CSH();
          });
          that.dialogVisible = false;
        } else {
          that.$message.error("表单验证失败，请检查输入");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.invoice {
  .invoice-list {
    padding-top: 0.2rem;
    .invoice-card {
      background: #ffffff;
      border: 1px solid #e5e5e5;
      border-radius: 0.13rem;
      overflow: hidden;
      position: relative;
      padding: 0.2rem 0.2rem;
      margin-top: 0.2rem;
      display: flex;
      align-items: flex-end;
      justify-content: space-between;

      .invoice-info {
        .default {
          position: absolute;
          right: 0;
          top: 0;
          background: linear-gradient(-49deg, #41b9e0 0%, #001ff5 100%);
          border-radius: 0rem 0rem 0rem 0.15rem;
          text-align: center;
          padding: 0.04rem 0.14rem;
        }
      }

      .invoice-actions {
        display: flex;
        > div {
          color: #959595;
          display: flex;
          align-items: center;
          cursor: pointer;

          &:hover {
            color: #001ff5;
          }
        }
        .edit {
          margin-right: 0.3rem;
        }
      }
    }
  }

  .add-invoice {
    margin-top: 1rem;
    cursor: pointer;
  }
}

/deep/ .invoiceDialog {
  .el-dialog {
    margin-top: 10vh !important;
    margin: 5vh auto;
  }
  .el-dialog__body {
    .el-form {
      .el-radio-group {
        margin-bottom: 30px;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  /deep/ .invoiceDialog .el-dialog {
    margin-top: 5vh !important;
    width: 94% !important;

    .el-dialog__body {
      .el-form {
        .el-radio-group {
          display: flex;
          gap: 0.2rem;
          flex-wrap: wrap;
          .el-radio {
            margin: 0;
          }
        }
      }
    }
  }
}
</style>
